import cx from "classnames";
import { useParallaxCaption } from "../../hooks/useParallaxCaption";
import bg from "./design-background.jpeg";
import "./Design.css";

const DesignSection = () => {
  const show = useParallaxCaption(1.9);

  return (
    <section className="section-design flex items-center">
      <div className="relative container mx-auto w-full h-full flex flex-col justify-center overflow-hidden">
        <div className="background">
          <img
            src={bg}
            alt="innovation-background"
            className="object-contain"
          />
        </div>
        <div className={cx("text", "fade", show && "show")}>
          <div className="title mb-10">
            <h1 className="font-medium nowrap">หน้ากากดีไซน์ใหม่</h1>
            <h2 className="large font-light nowrap sm:whitespace-nowrap">
              ส่งลมได้กว้างและ
              <span className="whitespace-nowrap">ไกลยิ่งขึ้น</span>
            </h2>
          </div>
          <p className="subtitle mb-9" style={{ maxWidth: 480 }}>
            ได้รับมาตรฐานประหยัดไฟ เบอร์ 5 ระดับ 5 ดาว{" "}
            <br className="hidden md:block" />
            (พัดลมไฟฟ้า ชนิดมอเตอร์กระแสสลับ แบบตั้งโต๊ะและแบบตั้งพื้น)
          </p>
          <p className="subtitle" style={{ maxWidth: 580 }}>
            *อ้างอิงจาก Website ของการไฟฟ้าฝ่ายผลิตแห่งประเทศไทย มกราคม 2567
          </p>
        </div>
      </div>
    </section>
  );
};

export default DesignSection;
